import React, { useState, useEffect } from 'react'
import TableView from './TableView'
import CustomDataGrid from '../CustomDataGrid'

const CustomTable = (props) => {
    console.log(props, 'propsCheck')
    return props?.enableTableView ? (
        <TableView props={props} />
    ) : global.enableDataGrid ? (
        <CustomDataGrid props={props} />
    ) : (
        <TableView props={props} />
    )
}

export default CustomTable
